import { Divider, Grid2, TextField, Typography } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { Product } from "@/shared/models/Product";
import { parseNumberInput } from "@/shared/utils/parseNumberInput";
import { toFraction32 } from "@/utils/fraction";

type Props = {
	control: Control<Product>;
	disabled: boolean;
};

export const SawSpecsFields = ({ control, disabled }: Props) => {
	return (
		<>
			<Grid2 size={{ xs: 12 }}>
				<Typography
					variant="subtitle2"
					fontWeight={600}
					color="primary"
					sx={{ mb: 0.5, mt: 1 }}
				>
					Saw Specs
				</Typography>
				<Divider />
			</Grid2>
			{/* Min | Target | Max, reading like the spec */}
			<Grid2 size={{ xs: 6, md: 4 }}>
				<Controller
					name="BottomTolerance"
					control={control}
					render={({ field }) => (
						<TextField
							label="Bottom"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(parseNumberInput(e.target.value, { min: 0 }))
							}
							onBlur={() => {
								field.onBlur();
								if (typeof field.value === "number") {
									const r = Math.round(field.value * 1000) / 1000;
									if (r !== field.value) field.onChange(r);
								}
							}}
							fullWidth
							size="small"
							disabled={disabled}
							helperText={
								typeof field.value === "number"
									? toFraction32(field.value)
									: undefined
							}
							inputProps={{ min: 0, step: 0.001 }}
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 6, md: 4 }}>
				<Controller
					name="TargetLength"
					control={control}
					render={({ field }) => (
						<TextField
							label="Target"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(parseNumberInput(e.target.value, { min: 0 }))
							}
							onBlur={() => {
								field.onBlur();
								if (typeof field.value === "number") {
									const r = Math.round(field.value * 1000) / 1000;
									if (r !== field.value) field.onChange(r);
								}
							}}
							fullWidth
							size="small"
							disabled={disabled}
							helperText={
								typeof field.value === "number"
									? toFraction32(field.value)
									: undefined
							}
							inputProps={{ min: 0, step: 0.001 }}
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 6, md: 4 }}>
				<Controller
					name="TopTolerance"
					control={control}
					render={({ field }) => (
						<TextField
							label="Top"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(parseNumberInput(e.target.value, { min: 0 }))
							}
							onBlur={() => {
								field.onBlur();
								if (typeof field.value === "number") {
									const r = Math.round(field.value * 1000) / 1000;
									if (r !== field.value) field.onChange(r);
								}
							}}
							fullWidth
							size="small"
							disabled={disabled}
							helperText={
								typeof field.value === "number"
									? toFraction32(field.value)
									: undefined
							}
							inputProps={{ min: 0, step: 0.001 }}
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 6, md: 4 }}>
				<Controller
					name="FinishPcB"
					control={control}
					render={({ field }) => (
						<TextField
							label="Finish Pc.B"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(
									parseNumberInput(e.target.value, { integer: true, min: 1 }),
								)
							}
							fullWidth
							size="small"
							disabled={disabled}
							inputProps={{ min: 1, step: 1 }}
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 6, md: 4 }}>
				<Controller
					name="MillLength"
					control={control}
					render={({ field }) => (
						<TextField
							label="Lgth"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(parseNumberInput(e.target.value, { min: 0 }))
							}
							onBlur={() => {
								field.onBlur();
								if (typeof field.value === "number") {
									const r = Math.round(field.value * 1000) / 1000;
									if (r !== field.value) field.onChange(r);
								}
							}}
							fullWidth
							size="small"
							disabled={disabled}
							inputProps={{ min: 0, step: 0.001 }}
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 6, md: 4 }}>
				<Controller
					name="MillPcB"
					control={control}
					render={({ field }) => (
						<TextField
							label="Mill Pc.B"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(
									parseNumberInput(e.target.value, { integer: true, min: 1 }),
								)
							}
							fullWidth
							size="small"
							disabled={disabled}
							inputProps={{ min: 1, step: 1 }}
						/>
					)}
				/>
			</Grid2>
		</>
	);
};
